const canvas = document.createElement('canvas')

const cxt = canvas.getContext('2d')

export function getTextWidth(text, font = '10pt Arial') {
  cxt.font = font
  return cxt.measureText(text).width
}
